import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=1420ab9f"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports